import { combineReducers } from 'redux';
import chatMessageReducer from './chatmessage/reducers';
import chatStatusReducer from './chatStatus/reducers';
import chatSettingReducer from './chatSetting/reducers';

import chatBaseDataReducer from './chatBaseData/reducers';

export const rootReducer = combineReducers({
  chatMessage: chatMessageReducer,
  chatStatus: chatStatusReducer,
  chatSetting: chatSettingReducer,
  chatBaseData: chatBaseDataReducer
});
export type AppState = ReturnType<typeof rootReducer>;
